import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES, MARKS } from '@contentful/rich-text-types';
import { useState } from 'react';
import { SUPPORT_URL } from '../../constants';
import React from "react"

// Developer note: 'options' definition is required to transform and render RichText raw nodes to HTML
// See pkg src for definition: https://github.com/contentful/rich-text/blob/master/packages/rich-text-html-renderer/src/index.ts
const options = {
    renderMark: {
        [MARKS.BOLD]: (text) => <b className='font-bold'>{text}</b>,
    },
    renderNode: {
        [INLINES.HYPERLINK]: (node, children) => {
            if (
              (node.data.uri.indexOf('avenuebank.com.au') > 0 ||
                node.data.uri.indexOf('localhost') > 0 ||
                node.data.uri.startsWith('#') ||
                node.data.uri.startsWith('/'))
              && node.data.uri.indexOf('.') === -1
            ) {
                return <a href={node.data.uri} className='underline'>{children}</a>;
            }

            return (
              <a
                href={node.data.uri}
                target='_blank'
                rel='noreferrer'
                className='underline'
              >
                  {children}
              </a>
            );
        },
        [BLOCKS.HEADING_2]: (node, children) => {
            return <h2>{children}</h2>;
        },
        [INLINES.ASSET_HYPERLINK]: (node, children) => {
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            return <a href='#'>{children}</a>;
        },
        [BLOCKS.PARAGRAPH]: (node, children) => {
            return <p className='align-center'>{children}</p>;
        },
    },
};

function FAQComponent({ faqs, currentPage, hideHelpAndSupport }) {
    const faqDetails = faqs[0].edges[0].node.faq;
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <section className='mb-5 bg-white'>
            <div className='container mx-auto max-w-4xl px-4 py-4 align-middle'>
                <div className='text-center text-4xl text-avenue-charade-500 sm:text-5xl'>
                    <blockquote className='mt-12 md:block'>Frequently Asked Questions</blockquote>
                </div>
                <div className='mb-10 mt-8 space-y-8'>
                    {faqDetails.map((faq, index) => (
                        <div className='rounded-lg border-2 border-gray-300'>
                            <div key={index}>
                                <button
                                    type='button'
                                    onClick={() => toggleFAQ(index)}
                                    className='flex w-full justify-between p-4 hover:bg-avenue-parchment-400'
                                    style={{ transition: 'background-color 1s ease' }}
                                >
                                    <h1 className='text-left font-semibold text-gray-700'>{faq.question}</h1>
                                    <span className='rounded-full bg-gray-200 text-gray-400'>
                                        <span>
                                            {activeIndex === index && (
                                                <svg
                                                    xmlns='http://www.w3.org/2000/svg'
                                                    className='h-6 w-6'
                                                    fill='none'
                                                    viewBox='0 0 24 24'
                                                    stroke='currentColor'
                                                >
                                                    <path
                                                        strokeLinecap='round'
                                                        strokeLinejoin='round'
                                                        strokeWidth='2'
                                                        d='M18 12H6'
                                                    />
                                                </svg>
                                            )}
                                            {activeIndex !== index && (
                                                <svg
                                                    xmlns='http://www.w3.org/2000/svg'
                                                    className='h-6 w-6'
                                                    fill='none'
                                                    viewBox='0 0 24 24'
                                                    stroke='currentColor'
                                                >
                                                    <path
                                                        strokeLinecap='round'
                                                        strokeLinejoin='round'
                                                        strokeWidth='2'
                                                        d='M12 6v6m0 0v6m0-6h6m-6 0H6'
                                                    />
                                                </svg>
                                            )}
                                        </span>
                                    </span>
                                </button>
                                <hr className='border-gray-300' />
                                <div
                                    className={`transition-max-height overflow-hidden duration-1000 ease-in-out ${
                                        activeIndex === index ? 'max-h-100' : 'max-h-0'
                                    }`}
                                    aria-expanded={activeIndex === index}
                                >
                                    <p className='p-8 text-sm text-avenue-charade-500 dark:text-avenue-charade-500'>
                                        <div>{documentToReactComponents(JSON.parse(faq.response.raw), options)}</div>
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {(currentPage === 'Home' || currentPage === 'BG') && !hideHelpAndSupport ? (
                    <div className='my-6 flex justify-center max-md:mt-10'>
                        <a
                            href={SUPPORT_URL}
                            id='apply-now-btn'
                            type='button'
                            className='apply-button max-width:100px display:block mt-5 whitespace-nowrap rounded-md bg-avenue-blue-500 px-8 py-4 text-center align-middle text-lg font-bold tracking-normal text-white shadow-lg transition delay-150 duration-300 ease-in-out hover:-translate-y-1 hover:scale-110 max-md:px-5'
                            target='_self'
                            rel='noreferrer'
                        >
                            Help and Support
                        </a>
                    </div>
                ) : null}
            </div>
        </section>
    );
}

export default FAQComponent;
